import React, {useState} from 'react';
import Grid from '@material-ui/core/Grid';
import {Popup, Text, List} from '../../../components';
import {Form} from 'react-final-form';

import EmailIcon from '@material-ui/icons/Email';
import PersonIcon from '@material-ui/icons/Person';
import LockIcon from '@material-ui/icons/Lock';

import {connect} from 'react-redux';


function User_update_popup(props){
    const[type, setType]=useState();
    const[password_no_match, setPasswordNoMatch]=useState(false);

    function onSubmit(params){
      if(type=='password'){if(params.new_password!=params.confirm_password){setPasswordNoMatch(true);}else{props.updatePassword({old_password:params.old_password, new_password:params.new_password});}}
      else if(type=='email'){props.updateEmail(params);}
      else if(type=='info'){props.updateUser(params);}
      props.handleClose();
    }

    return(
      <Form
        onSubmit={onSubmit}
        initialValues={{first_name:props.me.first_name, last_name:props.me.last_name, email:props.me.email}}
      >
        {form_props => (
          <form onsubmit={form_props.handleSubmit}>
          <Popup accept_button={(type==undefined)?undefined:'Update'} handleClose={props.handleClose} accept_button_click={()=>{form_props.form.submit();}} always_open title={(type==undefined)?'update_user_label':(type=='info')?'update_user_name_label':(type=='password')?'update_user_password_label':'update_user_email_label'} content={
            <div style={{width:'100%', width:'600px', marginTop:(type==undefined)?'0px':'30px', marginBottom:(type==undefined)?'60px':'30px'}}>
            {(type=='password')?
                <Grid container style={{width:'calc(100% - 60px)', marginLeft:'30px'}}>
                  <Grid item xs={12} sm={6}><Text type='password' error={(props.error=='wrong_password')?true:false} helperText={(props.error=='wrong_password')?'Incorrect password':undefined} title='Old password' name='old_password'/></Grid>
                  <Grid item xs={12} sm={6}><Text type='password' title='user_setup_label_new_password' name='new_password'/></Grid>
                  <Grid item xs={12} sm={6}><Text type='password' title='user_setup_label_confirm_password' error={password_no_match} helperText={(password_no_match==true)?"Passwords don't match":undefined} name='confirm_password'/></Grid>
                </Grid>
             :(type=='email')?
               <Grid container style={{width:'calc(100% - 60px)', marginLeft:'30px'}}>
                 <Grid item xs={12} sm={6}><Text title='user_setup_label_new_email' name='email'/></Grid>
                 <Grid item xs={12} sm={6}><Text type='password' error={(props.error=='wrong_password')?true:false} helperText={(props.error=='wrong_password')?'Incorrect password':undefined} title='user_setup_label_password' name='password'/></Grid>
               </Grid>
             :(type=='info')?
               <Grid container style={{width:'calc(100% - 60px)', marginLeft:'30px'}}>
                 <Grid item xs={12} sm={6}><Text title='user_setup_label_first_name' name='first_name'/></Grid>
                 <Grid item xs={12} sm={6}><Text title='user_setup_label_last_name' name='last_name'/></Grid>
                 <Grid item xs={12} sm={6}><Text type='password' error={(props.error=='wrong_password')?true:false} helperText={(props.error=='wrong_password')?'Incorrect password':undefined} title='user_setup_label_password' name='password'/></Grid>
               </Grid>
             :
              <List onClick={(x)=>{setType(x.type);}} list_data={[{type:'info', main_text:'update_user_name_label', icon:<PersonIcon color='primary'/>}, {type:'email', main_text:'update_user_email_label', icon:<EmailIcon color='primary'/>}, {type:'password', main_text:'update_user_password_label', icon:<LockIcon color='primary'/>}]} />
             }
      </div>
    }/>
      </form>
    )}</Form>
    )
}


export default connect(ss,dd)(User_update_popup);

function ss(state){
   return{
      error:state.account.error
   }
}

function dd(dispatch){
  return{
    updatePassword:(data)=>{dispatch({type:'REQUEST_UPDATE_PASSWORD', payload:data});},
    updateEmail:(data)=>{dispatch({type:'REQUEST_UPDATE_EMAIL', payload:data});},
    updateUser:(data)=>{dispatch({type:'REQUEST_UPDATE_USER', payload:data});}
  }
}
